// extracted by mini-css-extract-plugin
export default {"skipLinkButton":"SkipToContent_skipLinkButton__+QbOv"};